import Image from 'next/image';
import Link from 'next/link';
import { FC } from 'react';
import { IcoMoonIcon } from '../../../../../packages/ui/components/icons';

export const LeaderboardHead: FC<{
  hideLiveTag?: boolean;
  isLive?: boolean;
  name: string;
  moreHref?: string;
  moreText: string;
}> = ({ isLive, name, moreHref, hideLiveTag = false, moreText }) => {
  return (
    <div className="bg-back600 flex items-center justify-between gap-4 p-5">
      <div className="flex flex-grow flex-wrap items-center gap-2 break-all md:gap-5">
        <div className="bg-back200 relative flex size-10 items-center justify-center rounded-full md:size-14">
          <div className="relative size-5 md:size-8">
            <Image
              src="/assets/images/dashboard/player-leaderboard.svg"
              alt="Faction leaderboard"
              fill
            />
          </div>
        </div>
        <h5 className="text-text300 max-w-[50%] text-sm font-semibold uppercase">
          {name}
        </h5>
        {!hideLiveTag && (
          <div className="text-2xs leading-none md:text-xs">
            {isLive ? (
              <span className="bg-purple800 border-text600 rounded-6 px-3.5 py-1 text-xs font-medium text-white">
                Live
              </span>
            ) : (
              <div className="text-text600 border-text600 rounded-6 border px-2.5 py-1">
                Ended
              </div>
            )}
          </div>
        )}
      </div>
      {moreHref && (
        <Link
          href={moreHref}
          className="text-text600 hover:text-green700 flex items-center gap-2 text-xs underline md:no-underline"
        >
          {moreText}
          <IcoMoonIcon
            iconName="arrow-right"
            className="hidden size-[14px] md:block"
          />
        </Link>
      )}
    </div>
  );
};
